import React, { useMemo, useState } from 'react';
import { Modal, Form, InputNumber, Switch, Button, Space, Divider, Typography, App, Progress, Table } from 'antd';
import { PlusOutlined, WarningOutlined } from '@ant-design/icons';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var TeamSource = models.teams.TeamSource;
const FIRST = ['Alex', 'Taylor', 'Jordan', 'Sam', 'Casey', 'Avery', 'Riley', 'Charlie', 'Jamie', 'Robin', 'Luca', 'Eden', 'Skyler', 'Finley', 'Morgan', 'Kai', 'Mika', 'Sasha', 'Rowan', 'Quinn', 'Elliot', 'River', 'Peyton', 'Hayden', 'Marley', 'Emery', 'Reese', 'Dakota', 'Kendall', 'Cameron'];
const LAST = ['Holloway', 'Briar', 'Kingsley', 'Ashford', 'Ravenshade', 'Hawthorne', 'Vale', 'Silverwind', 'Thorne', 'Locke', 'Brighton', 'Corren', 'Westfield', 'Vance', 'Calder', 'Hartwell', 'Merrin', 'Larkspur', 'Voss', 'Ellington', 'Arden', 'Perrin', 'Lowell', 'Stroud', 'Carron', 'Aster', 'Harrow', 'Northwell', 'Everly'];
const COUNTRIES = ['SE', 'NO', 'DK', 'FI', 'IS', 'DE', 'EE'];
const CLUBS = [
    'Crimson Rhythm Society', 'Electric Groove Collective', 'Midnight Tempo Crew', 'Golden Step Academy',
    'Velvet Swing Circle', 'Neon Motion Studio', 'Silverbeat Dance Company', 'Twilight Boogie Club',
    'Echo Move Union', 'Firestep Collective', 'Moonlight Flow Society', 'Gravity Groove Project',
    'Pulse & Flow Danceworks', 'The Shuffle Syndicate', 'Luminous Rhythm Ensemble', 'Fusion Beat Network',
    'Velocity Dance Tribe', 'Solarstep Crew', 'VibeCraft Dance Union', 'Momentum Motion House'
];
const REUSE_TEAM_ORG_PROB = 0.45;
const MEMBER_BASE_ORG_PROB = 0.8;
const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const randDigits = (n) => Array.from({ length: n }, () => Math.floor(Math.random() * 10)).join('');
const abbrevClub = (name) => name.split(/\s+/).filter(Boolean).map(w => w[0].toUpperCase()).join('');
const uniqueInOrder = (arr) => {
    const seen = new Set();
    const out = [];
    for (const v of arr)
        if (v && !seen.has(v)) {
            seen.add(v);
            out.push(v);
        }
    return out;
};
const pickName = () => ({ first: rand(FIRST), last: rand(LAST) });
function genMembers(count, withCountries, withOrgs, teamBaseOrgFull, fixedCountry) {
    const out = [];
    for (let i = 0; i < count; i++) {
        const n = pickName();
        let org_full = undefined;
        if (withOrgs) {
            const useBase = teamBaseOrgFull && Math.random() < MEMBER_BASE_ORG_PROB;
            org_full = useBase ? teamBaseOrgFull : rand(CLUBS);
        }
        out.push({
            first_name: n.first,
            last_name: n.last,
            country_code: withCountries ? (fixedCountry || rand(COUNTRIES)) : undefined,
            org_full,
            org_abbr: org_full ? abbrevClub(org_full) : undefined,
        });
    }
    return out;
}
export const generateRandomTeamPreview = (options) => {
    const teams = [];
    const count = Math.min(100, Math.max(1, options.teamCount));
    const membersPerTeam = Math.max(1, Math.min(3, options.membersPerTeam));
    const usedBaseOrgs = [];
    for (let i = 0; i < count; i++) {
        let teamBaseOrgFull = undefined;
        if (options.includeRepresentation) {
            if (usedBaseOrgs.length > 0 && Math.random() < REUSE_TEAM_ORG_PROB) {
                teamBaseOrgFull = rand(usedBaseOrgs);
            }
            else {
                teamBaseOrgFull = rand(CLUBS);
                if (!usedBaseOrgs.includes(teamBaseOrgFull))
                    usedBaseOrgs.push(teamBaseOrgFull);
            }
        }
        const members = genMembers(membersPerTeam, options.includeCountry, options.includeRepresentation, teamBaseOrgFull, options.fixedCountry);
        const uniqueAbbr = uniqueInOrder(members.map(m => m.org_abbr));
        const uniqueFull = uniqueInOrder(members.map(m => m.org_full));
        const team_org = uniqueAbbr.length ? uniqueAbbr.join('/') : undefined;
        const team_org_full = uniqueFull.length ? uniqueFull.join('/') : undefined;
        teams.push({
            key: i,
            team_org,
            team_org_full,
            team_country: options.includeCountry ? (options.fixedCountry || rand(COUNTRIES)) : undefined,
            members
        });
    }
    return teams;
};
const applyMemberFields = (dst, members) => {
    const full = (p) => p ? `${p.first_name} ${p.last_name}` : undefined;
    const setMember = (idx, m) => {
        var _a;
        dst[`team_name_${idx}`] = m ? full(m) : undefined;
        dst[`team_org_${idx}`] = (_a = m === null || m === void 0 ? void 0 : m.org_abbr) !== null && _a !== void 0 ? _a : undefined;
        dst[`team_license_${idx}`] = m ? `LIC-${randDigits(5)}` : undefined;
        dst[`team_person_id_${idx}`] = m ? randDigits(5) : undefined;
        dst[`team_year_${idx}`] = m ? String(randInt(2000, 2018)) : undefined;
    };
    setMember(1, members[0]);
    setMember(2, members[1]);
    setMember(3, members[2]);
    return dst;
};
export const mapGeneratedTeamToApiTeam = (g, classId) => {
    const clsId = classId !== null && classId !== void 0 ? classId : null;
    const payload = {
        class_id: clsId,
        team_org: g.team_org,
        team_org_full: g.team_org_full,
        team_country: g.team_country,
        team_starting_in: clsId,
        team_placement: '',
        team_sum: '',
        team_cancelled: 0,
        team_disqualified: false,
        team_checked_in: false,
    };
    applyMemberFields(payload, g.members);
    return payload;
};
export const GenerateRandomTeams = ({ competition_id, classItem, visible, onClose }) => {
    const { notification } = App.useApp();
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [created, setCreated] = useState(0);
    const [errors, setErrors] = useState(0);
    const [preview, setPreview] = useState([]);
    useMemo(() => null, []);
    const initial = {
        teamCount: 8,
        membersPerTeam: 2,
        includeCountry: true,
        includeRepresentation: true,
    };
    const regenerate = (vals) => {
        setPreview(generateRandomTeamPreview({
            teamCount: vals.teamCount,
            membersPerTeam: vals.membersPerTeam,
            includeCountry: vals.includeCountry,
            includeRepresentation: vals.includeRepresentation,
        }));
    };
    const handleValuesChange = () => regenerate(form.getFieldsValue());
    const handleOpen = () => { form.setFieldsValue(initial); regenerate(initial); setProgress(0); setCreated(0); setErrors(0); };
    const handleGenerate = async () => {
        var _a, _b;
        if (!preview.length)
            return;
        setIsLoading(true);
        setProgress(0);
        setCreated(0);
        setErrors(0);
        const apiPayloads = preview.map((team) => mapGeneratedTeamToApiTeam(team, classItem === null || classItem === void 0 ? void 0 : classItem.class_id));
        const teamURL = TeamSource(competition_id).url;
        const total = apiPayloads.length;
        try {
            for (let i = 0; i < total; i++) {
                try {
                    await Api.create(teamURL, apiPayloads[i]);
                    setCreated((c) => c + 1);
                }
                catch (err) {
                    setErrors((e) => e + 1);
                    notification.error({ message: (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : _T('common.error'), icon: React.createElement(WarningOutlined, { style: { color: 'red' } }) });
                }
                setProgress(Math.floor(((i + 1) / total) * 100));
            }
            if (errors === 0)
                notification.success({ message: _T('common.import.success') });
        }
        catch (e) {
            notification.error({ message: (_b = e === null || e === void 0 ? void 0 : e.message) !== null && _b !== void 0 ? _b : _T('common.error') });
        }
        finally {
            setIsLoading(false);
        }
    };
    const columns = [
        { title: '#', dataIndex: 'key', width: 50, render: (v) => v + 1 },
        { title: _T('team.details.team_org.label'), dataIndex: 'team_org', width: 140 },
        { title: _T('team.details.team_country.label'), dataIndex: 'team_country', width: 100 },
        {
            title: _T('common.name'),
            dataIndex: 'members',
            render: (members) => (React.createElement(React.Fragment, null, members.map((m, i) => (React.createElement("div", { key: i },
                m.first_name,
                " ",
                m.last_name,
                m.country_code ? ` · ${m.country_code}` : '',
                m.org_abbr ? ` · ${m.org_abbr}` : ''))))),
        },
        { title: _T('team.details.team_org_full.label'), dataIndex: 'team_org_full', responsive: ['lg'] },
    ];
    return (React.createElement(Modal, { open: visible, onCancel: isLoading ? undefined : onClose, title: _T('team.generate'), width: 900, footer: React.createElement(Button, { type: "primary", icon: React.createElement(PlusOutlined, null), loading: isLoading, onClick: handleGenerate }, _T('common.create')), afterOpenChange: (o) => { if (o)
            handleOpen(); }, destroyOnHidden: true, mask: { closable: !isLoading } },
        React.createElement(Space, { orientation: "vertical", style: { width: '100%' }, size: "large" },
            React.createElement(Form, { form: form, layout: "inline", initialValues: initial, onValuesChange: handleValuesChange, style: { display: 'flex', flexWrap: 'wrap', gap: 12 } },
                React.createElement(Form.Item, { name: "teamCount", label: _T('class.count') },
                    React.createElement(InputNumber, { min: 1, max: 100, disabled: isLoading })),
                React.createElement(Form.Item, { name: "membersPerTeam", label: _T('team.title') },
                    React.createElement(InputNumber, { min: 1, max: 3, disabled: isLoading })),
                React.createElement(Form.Item, { name: "includeCountry", label: _T('team.details.team_country.label') },
                    React.createElement(Switch, { disabled: isLoading })),
                React.createElement(Form.Item, { name: "includeRepresentation", label: _T('team.details.team_org.label') },
                    React.createElement(Switch, { disabled: isLoading }))),
            React.createElement(Divider, { style: { margin: '8px 0' } }),
            (isLoading || progress > 0) && (React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                React.createElement(Progress, { percent: progress, status: progress < 100 ? 'active' : undefined }),
                React.createElement(Typography.Text, { type: errors ? 'danger' : 'secondary' },
                    _T('common.status'),
                    ": ",
                    _T('common.create'),
                    " ",
                    created,
                    "/",
                    preview.length,
                    errors ? ` — ${errors} ${_T('common.errors')}` : ''))),
            React.createElement(Table, { size: "small", columns: columns, dataSource: preview, pagination: false, bordered: true, scroll: { y: 360 } }))));
};
